import React from 'react'
import { useTheme } from '@mui/material/styles'
import { useNavigate as useNavigateReactRouterDom } from 'react-router-dom'

const getWindowDimensions = () => {
	const { innerWidth: width, innerHeight: height } = window
	return {
		width,
		height,
	}
}

export const useWindowDimensions = (): { width: number; height: number } => {
	const [windowDimensions, setWindowDimensions] = React.useState(getWindowDimensions())

	const handleResize = React.useCallback(() => {
		setWindowDimensions(getWindowDimensions())
	}, [])

	React.useEffect(() => {
		setWindowDimensions(getWindowDimensions())
		window.addEventListener('resize', handleResize)
		return () => window.removeEventListener('resize', handleResize)
	}, [handleResize])

	return windowDimensions
}

export const usePxPerRemFactor = (): number => {
	const theme = useTheme()
	const pxPerRem = 1 / Number(theme.typography.pxToRem(1).replace('rem', ''))
	return pxPerRem
}

// TODO: replace with react-router-dom useNavigate
export const useNavigate = () => {
	const navigate = useNavigateReactRouterDom()
	return React.useCallback(
		(route) => {
			navigate(route)
		},
		[navigate]
	)
}
